import Layout from '@/components/feature/Layout';
import HeroSection from './components/HeroSection';
import QuickAccess from './components/QuickAccess';

export default function HomePage() {
  return (
    <Layout>
      <HeroSection />
      <QuickAccess />
    </Layout>
  );
}